module.exports = __webpack_public_path__ + "static/media/50.fb284399.JPG";